import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import WorkHubLayout from "./components/WorkHubLayout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import AdminPanel from "./pages/AdminPanel";
import ContentHub from "./components/ContentHub";
import CreateCampaign from "./pages/campaigns/CreateCampaign";
import CampaignsList from "./pages/campaigns/CampaignsList";
import ApprovalQueue from "./pages/campaigns/ApprovalQueue";
import DraftsList from "./pages/campaigns/DraftsList";
import CampaignView from "./pages/campaigns/CampaignView";
import OfferBuilder from "./pages/offers/OfferBuilder";
import SavedOffers from "./pages/offers/SavedOffers";
import OfferTemplates from "./pages/offers/OfferTemplates";
import EmailCampaignsDashboard from "./pages/email-campaigns/EmailCampaignsDashboard";
import BusinessProfileSetup from "./pages/email-campaigns/BusinessProfileSetup";
import EmailCampaignBuilder from "./pages/email-campaigns/EmailCampaignBuilder";
import EmailCampaignView from "./pages/email-campaigns/EmailCampaignView";
import CreativeGeneratorPage from "./pages/creative-generator/CreativeGeneratorPage";
import ClientDashboard from "./pages/client-dashboard/ClientDashboard";
import TriageList from "./pages/triage/TriageList";
import TriageCockpit from "./pages/triage/TriageCockpit";
import TriageSummary from "./pages/triage/TriageSummary";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Protected Routes with Layout */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <Dashboard />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin" element={
              <ProtectedRoute adminOnly>
                <WorkHubLayout>
                  <AdminPanel />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            
            {/* Content Hub */}
            <Route path="/create" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <ContentHub />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/create/:projectId" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <ContentHub />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            
            {/* Campaigns */}
            <Route path="/campaigns" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <CampaignsList />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/campaigns/create" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <CreateCampaign />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/campaigns/queue" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <ApprovalQueue />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/campaigns/drafts" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <DraftsList />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/campaigns/:campaignId" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <CampaignView />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            
            {/* Offers */}
            <Route path="/offers/build" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <OfferBuilder />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/offers/build/:offerId" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <OfferBuilder />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/offers/saved" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <SavedOffers />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/offers/templates" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <OfferTemplates />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            
            {/* Email Campaigns */}
            <Route path="/email-campaigns" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <EmailCampaignsDashboard />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/email-campaigns/profile" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <BusinessProfileSetup />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/email-campaigns/profile/:profileId" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <BusinessProfileSetup />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/email-campaigns/create" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <EmailCampaignBuilder />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/email-campaigns/:campaignId" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <EmailCampaignView />
                </WorkHubLayout>
              </ProtectedRoute>
            } />

            {/* Creative Generator */}
            <Route path="/creative-generator" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <CreativeGeneratorPage />
                </WorkHubLayout>
              </ProtectedRoute>
            } />

            {/* Client Dashboard */}
            <Route path="/client-dashboard" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <ClientDashboard />
                </WorkHubLayout>
              </ProtectedRoute>
            } />

            {/* Triage Call Cockpit */}
            <Route path="/triage" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <TriageList />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/triage/new" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <TriageCockpit />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/triage/:callId" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <TriageCockpit />
                </WorkHubLayout>
              </ProtectedRoute>
            } />
            <Route path="/triage/:callId/summary" element={
              <ProtectedRoute>
                <WorkHubLayout>
                  <TriageSummary />
                </WorkHubLayout>
              </ProtectedRoute>
            } />

            {/* Default Redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
